import { PagePermission, Permission } from '@jiaofa/constants'

const editToViewPermissions: Record<string, string> = {
  [Permission.DashboardEdit]: Permission.DashboardView,
  [Permission.OrderEdit]: Permission.OrderView,
  [Permission.RefundEdit]: Permission.RefundView,
  [Permission.StoreEdit]: Permission.StoreView,
  [Permission.ProductEdit]: Permission.ProductView,
  [Permission.DeliveryEdit]: Permission.DeliveryView,
  [Permission.DroneEdit]: Permission.DroneView,
  [Permission.UserEdit]: Permission.UserView,
  [Permission.MemberEdit]: Permission.MemberView,
  [Permission.MarketingEdit]: Permission.MarketingView,
  [Permission.DataEdit]: Permission.DataView,
  [Permission.FinanceEdit]: Permission.FinanceView,
  [Permission.MessageEdit]: Permission.MessageView,
  [Permission.SystemEdit]: Permission.SystemView,
  [Permission.SystemRoleEdit]: Permission.SystemRoleView,
  [Permission.ProfitSharingManage]: Permission.ProfitSharingView,
  [Permission.ProfitSharingExecute]: Permission.ProfitSharingView,
}

// 页面级权限：勾「操作」自动补「查看」（能操作必先能查看）。
Object.values(PagePermission).forEach((page) => {
  editToViewPermissions[page.edit] = page.view
})

export const expandImplicitPermissions = (permissions: readonly string[]): string[] => {
  const expanded = new Set(permissions.filter(Boolean))
  permissions.forEach((permission) => {
    const viewPermission = editToViewPermissions[permission]
    if (viewPermission) expanded.add(viewPermission)
  })
  return [...expanded]
}

